"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateChart = useCreateChart;
var React = _interopRequireWildcard(require("react"));
var _initChart = require("./initChart");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Chart = (0, _initChart.getChart)();
function useCreateChart(canvasCtx, chartCfg, props) {
  const {
    chartRef: chartRefFromProps
  } = props;
  const chartRef = React.useRef(null);
  React.useEffect(() => {
    if (canvasCtx && chartCfg && !chartRef.current) {
      const chart = new Chart(canvasCtx, chartCfg);
      chartRef.current = chart;
      if (chartRefFromProps) {
        chartRefFromProps.current = chart;
      }
    }
  }, [canvasCtx, chartCfg, chartRefFromProps]);
  return chartRef;
}